<div class="block-schedule__top">
    <ridango-ui-back-button>
        <a [routerLink]="'/schedule' | localize">{{ 'LOCAL_BTN_BACK' | translate }}</a>
    </ridango-ui-back-button>
    <h1>{{'SCHEDULE_PLANNER_TITLE' | translate}}</h1>
    <p>{{'SCHEDULE_PLANNER_DESCRIPTION' | translate}}</p>

    <form [formGroup]="planRideForm" autocomplete="off" (ngSubmit)="submit()" ridangoFocusInvalidInput>
        <ridango-ui-swappable-inputs>
            <ridango-ui-autocomplete-input formControlName="originFeature" [label]="'PH_PLANNER_FROM' | translate"
                [options]="origins$ | async" [noMargin]="true" [inputDisplayFn]="suggestionsDisplayCallback"
                (onInputChanged)="originSearched($event)" (onOptionSelected)="originSelected($event)">
            </ridango-ui-autocomplete-input>

            <ridango-ui-autocomplete-input formControlName="destinationFeature" [label]="'PH_PLANNER_TO' | translate"
                [options]="destinations$ | async"
                [errorMessage]="'PLAN_RIDE_LOCATIONS_REQUIRED_ERROR' | translate"
                [inputDisplayFn]="suggestionsDisplayCallback" (onInputChanged)="destinationSearched($event)"
                (onOptionSelected)="destinationSelected($event)">
            </ridango-ui-autocomplete-input>
        </ridango-ui-swappable-inputs>

        <div class="margin-bottom-20">
            <ridango-datepicker [date]="date" (dateUpdated)="updateDateField($event)" [useMaterialIcon]="true"></ridango-datepicker>
        </div>

        <ridango-ui-time-input formControlName="time"></ridango-ui-time-input>

        <ridango-form-field>
            <div class="ridango-radio-field">
                <input id="priorityDeparture" type="radio" [value]="0" name="priority"
                    formControlName="priority"  (click)="changePriority(0)" ridangoInput>
                <label for="priorityDeparture">{{ 'PLANNER_PRIORITY_DEPARTURE' | translate }}</label>
            </div>

            <div class="ridango-radio-field">
                <input id="priorityArrival" type="radio" [value]="1" name="priority"
                    formControlName="priority" (click)="changePriority(1)" ridangoInput>
                <label for="priorityArrival">{{ 'PLANNER_PRIORITY_ARRIVAL' | translate }}</label>
            </div>
        </ridango-form-field>

        <div>
            <button class="btn btn--maximal btn--primary btn--big" type="submit">
                {{ 'BUTTON_NEXT' | translate }}
            </button>
        </div>
    </form>
</div>

<div class="block-schedule__bottom" [attr.aria-busy]="!(tripsLoading$ | async)">
    <ridango-ui-basic-loading-spinner *ngIf="tripsLoading$ | async" [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
    </ridango-ui-basic-loading-spinner>

    <ng-container *ngIf="!(tripsLoading$ | async) && planRideForm.valid">
        <div *ngIf="!(trips$ | async)" class="padding-10">
            <p class="bold">{{'SCHEDULE_PLANNER_NO_TRIPS_FOUND' | translate}}</p>
            <p>{{'SCHEDULE_PLANNER_NO_TRIPS_FOUND_DESCRIPTION' | translate}}</p>
        </div>


        <div *ngIf="(trips$ | async)?.length > 0">
            <p class="bold padding-10">{{(trips$ | async).length}} {{'SCHEDULE_PLANNER_TRIPS_FOUND' | translate}}</p>

            <ul class="remove-bullets route-list">
                <li  *ngFor="let trip of (trips$ | async); let index = index;">
                    <div class="flex padding-10 planner-trips-times">
                        <div class="flex1 bold">
                            {{trip.LegList.Leg[0].Origin.time | timeFromString:'hh:mm'}}  <span class="icon icon-arrow-right-link align-self-center"></span>
                            {{trip.LegList.Leg[trip.LegList.Leg.length-1].Destination.time | timeFromString:'hh:mm'}}
                        </div>

                        <div class="planner-trips-times__duration align-self-center">{{ trip.duration | duration }}</div>
                    </div>

                    <a class="link link--no-line link--no-hover flex-center full-width min-height-60 planner-trips-info-items" (click)="selectTrip(index)">
                        <div class="flex flex1 position-relative min-height-50 padding-10">
                            <div class="flex1">
                                <span *ngFor="let leg of trip.LegList.Leg; let last = last;">
                                    <span *ngIf="leg.type === 'WALK' && leg.dist > 0" class="walk"><span class="icon icon-walking"></span> {{leg.dist}}m</span>
                                    <span *ngIf="leg.type === 'BIKE' && leg.dist > 0" class="bike"><span class="icon icon-bike2"></span>{{leg.dist}}m</span>

                                    <span *ngIf="leg.type === 'JNY' && leg.Product[0] && leg.Product[0].catCode"
                                        class="{{'transport-type-' + leg.Product[0].catCode}}"
                                        [ngSwitch]="leg.Product[0].catCode">
                                        <span *ngSwitchCase="'1'" class="icon icon-train"></span>
                                        <span *ngSwitchCase="'2'" class="icon icon-train"></span>
                                        <span *ngSwitchCase="'3'" class="icon icon-bus2"></span>
                                        <span *ngSwitchCase="'4'" class="icon icon-train"></span>
                                        <span *ngSwitchCase="'5'" class="icon icon-subway"></span>
                                        <span *ngSwitchCase="'6'" class="icon icon-train"></span>
                                        <span *ngSwitchCase="'7'" class="icon icon-bus"></span>
                                        <span *ngSwitchCase="'8'" class="icon icon-ferry"></span>
                                        <span *ngSwitchCase="'9'" class="icon icon-car"></span>
                                        <span class="line-number">{{leg.Product[0].displayNumber}}</span>
                                    </span>

                                    <!--
                                        TRSF means a part of journey unscheduled by Resobot, or more commonly, a long wait.
                                        In ResRobot, it is shown a long line/bar of same color as previous transport type.
                                        Might be that we skip it completely?
                                    -->
                                    <!--<span *ngIf="leg.type === 'TRSF'" [ngClass]="(leg.Product && leg.Product.catCode) ? 'transport-type-' + leg.Product?.catCode : ''">WAIT</span>-->

                                    <span *ngIf="!last && leg.type !== 'TRSF' && leg.dist !== 0"
                                        class="icon icon-arrow-right-link align-self-center divider">
                                    </span>
                                </span>
                            </div>

                            <span class="icon icon-arrow-right-link align-self-center"></span>
                            <div class="route-list--hr"></div>
                        </div>
                    </a>
                </li>
            </ul>


        </div>
    </ng-container>
</div>
